import { useCallback, useState } from 'react';

export function useImageLightbox(images) {
  const [activeIndex, setActiveIndex] = useState(null);
  const isOpen = activeIndex !== null;

  const close = useCallback(() => {
    setActiveIndex(null);
  }, []);

  const open = useCallback((index) => {
    setActiveIndex(index);
  }, []);

  const showPrevious = useCallback(() => {
    setActiveIndex((currentIndex) => {
      if (currentIndex === null || images.length === 0) return null;
      return currentIndex === 0 ? images.length - 1 : currentIndex - 1;
    });
  }, [images.length]);

  const showNext = useCallback(() => {
    setActiveIndex((currentIndex) => {
      if (currentIndex === null || images.length === 0) return null;
      return currentIndex === images.length - 1 ? 0 : currentIndex + 1;
    });
  }, [images.length]);

  return {
    activeImage: activeIndex === null ? null : images[activeIndex],
    activeIndex,
    close,
    isOpen,
    open,
    showNext,
    showPrevious,
  };
}
